package ai.flowstorm.studio.model

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity
import kotlinx.serialization.Serializable

@Serializable
data class Style(
    override val _id: Id = newId(),
    val name: String
):AbstractEntity() {
    override val label: String
        get() = name
}
